
<div class="form-row" [ngClass]="{ 'form-required': label && required, 'invalid': required && !primaryValue }">
    <div class="label" *ngIf="langs.length || label">
        <label [for]="id">{{ label ? (label | translate) : '&nbsp;' }}</label>

        <div class="label-langs" *ngIf="langs && langs.length">
            <a
                *ngFor="let lang of langs"
                (click)="onChangeLang(lang.id);activeLangChange.emit(lang.id)"
                [ngClass]="{ 'active': lang.id === activeLang, 'primary-lang': isPrimaryLang(lang.id) }">
                {{ lang.name }}
                <span class="mark" [ngClass]="{ 'mark-empty': isEmpty(lang.id) }"></span>
            </a>
        </div>
    </div>

    <input
        *ngIf="type === 'input'"
        type="text"
        #value="ngModel"
        value="{{ value }}"
        [id]="id"
        [required]="isPrimaryLang() && required"
        [placeholder]="placeholder | translate"
        [name]="key"
        [autocomplete]="key"
        [disabled]="disabled"
        [(ngModel)]="model"
        (blur)="onBlur($event)"
        (focus)="onFocus($event)"
        (ngModelChange)="onChangeValue($event)" />

    <textarea
        *ngIf="type === 'textarea'"
        [id]="id"
        [required]="isPrimaryLang() && required"
        [placeholder]="placeholder | translate"
        [name]="key"
        [rows]="rows"
        [disabled]="disabled"
        [(ngModel)]="model"
        (blur)="onBlur($event)"
        (focus)="onFocus($event)"
        (ngModelChange)="onChangeValue($event)">
    </textarea>

    <app-tag-editor
        *ngIf="type === 'tag'"
        [id]="id"
        [required]="isPrimaryLang() && required"
        [placeholder]="placeholder | translate"
        [name]="key"
        [rows]="rows"
        [tags]="tags"
        [disabled]="disabled"
        [(ngModel)]="model"
        (blur)="onBlur($event)"
        (focus)="onFocus($event)"
        (ngModelChange)="onChangeValue($event)">
    </app-tag-editor>
</div>
